export class VisitaEmpresaSaveModel {
    Id: number;
    PlannedDate: string;
    DoneDate: string;
    Type: string;
    Assistant: string;
    Concept: string;
    Description: string;
    CompanyId: number;
    AsistentesEmpresa:string;
    AsistentesMutua:string;
    Comentarios:string;
    constructor() {
        this.Id = 0;
    }
}

export class VisitaEmpresa {
    id: number;
    empresaId: number;
    fecha: string;
    tipo: string;
    isDone: boolean;
    visitDetails: VisitaEmpresaDetails;
}

export class VisitaEmpresaDetails {
    id: number;
    empresaId: number;
    mes: number;
    anyo: number;
    coordinador1: string;
    coordinador2: string;
    planificada: string;
    realizada: string;
    estudioPlanificado: string;
    estudioPresentado: string;
    asistentes: string;
    comentarios: string;
    asunto: string;
    tipo: string;
    resumen: string;
    planificadoPor: string;
    realizadoPor: string;
    fplanificacion: string;
    frealizacion: string;
    funcionaMedico: string;
    medicoIntegrado: string;
    cumpleHorario: string;
    problemas: string;
    informacionPuntual: string;
    trasladoProblemas: string;
    lugar: string;
    efectiva: string;
    asistentesEmpresa: string;
    asistentesMutua: string;
    valoracion: number;
}
